import React from "react";
import { Container, Row, Col, Button } from "reactstrap";

const SLaBrea629 = () => {
  document.title = "629 S La Brea | CurbDash";

  const backgroundStyle = {
    height: "100vh",
    background: "linear-gradient(135deg, #ffffff, #f0f0f0)", // change this to any color or gradient
  };

  const buttonStyle = {
    padding: "1rem",
    fontSize: "1.2rem",
    fontWeight: 600,
    background: "linear-gradient(135deg, #1e1e1e, #4a4a4a)", // change this to any color or gradient
    border: "none",
  };

  const handleButtonClick = (type) => {
    if (type === "Compact") {
      window.open("https://buy.stripe.com/14A9AM2bU15fcRjg5ZgA82k", "_blank");
    } else if (type === "SUV") {
      window.open("https://buy.stripe.com/00w6oA6sadS1eZr3jdgA82l", "_blank");
    } else if (type === "Overnight") {
      window.open("https://buy.stripe.com/aFa4gsaIqeW58B34nhgA82m", "_blank");
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center" style={backgroundStyle}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={6}>
            <img
              src="/cs-logo-circle.png"
              alt="Curbstand Logo"
              style={{ width: "60%", maxWidth: 280, marginBottom: 30 }}
            />
            <h2 className="text-dark mb-5 fw-semibold" style={{ fontSize: "2rem" }}>
              629 S La Brea
            </h2>

            <div className="d-grid gap-3 mb-3">
              <Button style={buttonStyle} onClick={() => handleButtonClick("Compact")}>
                Pay Compact
              </Button>
            </div>
            <div className="d-grid gap-3 mb-3">
              <Button style={buttonStyle} onClick={() => handleButtonClick("SUV")}>
                Pay SUV
              </Button>
            </div>
            <div className="d-grid gap-3 mb-3">
              <Button style={buttonStyle} onClick={() => handleButtonClick("Overnight")}>
                Pay Overnight
              </Button>
            </div>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <p className="text-muted mb-0" style={{ fontSize: 18, marginRight: 8 }}>
                Powered by
              </p>
              <a href="https://www.curbstand.com/" target="_blank" rel="noreferrer">
                <img
                  src="/cs_horizontal_logo.webp"
                  alt="Curbstand"
                  style={{ height: 28 }}
                />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SLaBrea629;